module.exports = __webpack_public_path__ + "img/38757-131.6c895834.jpg";